import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
//services
import {ObservablepostService} from "./services/observablepost.service";
import {UserService} from "./services/user.service";
import {LocalDataService} from "./services/local-data.service";
import {PublicationsService} from "./services/publications.service";
import {CommentService} from "./services/comment.service";
//toast
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

//new Services
import { LoginService } from "./nservices/login/login.service";
import { CredentialsService } from "./nservices/login/credentials.service";
import { PublicationService } from "./nservices/publication.service";
import { FilterService } from "./nservices/map/filter.service";
import { SharedinfoService } from "./nservices/sharedinfo.service";

//Angular Google Maps
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';

import {HttpModule} from "@angular/http";

import {APP_ROUTING} from "./app.routes";

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { MapComponent } from './map/map.component';
import { AsideComponent } from './aside/aside.component';
import { NewPostComponent } from './new-post/new-post.component';
import { MypublicationsComponent } from './mypublications/mypublications.component';
import { EditpublicationComponent } from './editpublication/editpublication.component';
import { PrivacidadComponent } from './privacidad/privacidad.component';
import { DetailsPublicationComponent } from './details-publication/details-publication.component';
import { AboutComponent } from './about/about.component';
import { TimeformatPipe } from './pipes/timeformat.pipe';
import { LocaltimeformatPipe } from './pipes/localtimeformat.pipe';
import { DetailsmypublicationComponent } from './detailsmypublication/detailsmypublication.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    HeaderComponent,
    MapComponent,
    AsideComponent,
    NewPostComponent,
    MypublicationsComponent,
    EditpublicationComponent,
    PrivacidadComponent,
    DetailsPublicationComponent,
    AboutComponent,
    TimeformatPipe,
    LocaltimeformatPipe,
    DetailsmypublicationComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    APP_ROUTING,
    AngularFontAwesomeModule,
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA9sBWcHp10MUhqh-7K2WXWUD4RxTqAugo',
      libraries: ['geometry', 'places']
    }),
    AgmSnazzyInfoWindowModule
  ],
  providers: [
    UserService,
    LocalDataService,
    PublicationsService,
    CommentService,
    ObservablepostService,
    //new services
    LoginService,
    CredentialsService,
    PublicationService,
    FilterService,
    SharedinfoService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/app.module.ts